import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useConsultation } from "../../../context/ConsultationContext";

/**
 * Slim, on-light or on-dark CTA strip designed to break up long scrolls
 * without competing with the closing CTA hero.
 */
export default function InlineCTA({
  eyebrow = "Ready when you are",
  title = "Let's design your UAE setup roadmap.",
  buttonLabel = "Get In Touch",
  service = "other",
  variant = "light",
}) {
  const { open } = useConsultation();
  const dark = variant === "dark";

  return (
    <section
      data-testid="v2-inline-cta"
      className={`relative ${dark ? "bg-[#001A4D] text-white" : "bg-white text-[#0F172A]"} border-y ${dark ? "border-white/10" : "border-slate-200"}`}
    >
      <div className="container-x py-8 md:py-10 grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5 }}
          className="md:col-span-9"
        >
          <p
            className={`overline ${dark ? "text-[#6B8AFF]" : "text-[#3366FF]"}`}
          >
            {eyebrow}
          </p>
          <h3
            className={`mt-3 font-heading font-light tracking-tight text-xl md:text-2xl leading-tight ${
              dark ? "text-white" : "text-[#0F172A]"
            }`}
          >
            {title}
          </h3>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="md:col-span-3 md:justify-self-end"
        >
          <button
            data-testid="v2-inline-cta-btn"
            onClick={() => open(service)}
            className="btn-gold w-full md:w-auto text-sm"
          >
            {buttonLabel} <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
